import * as GC from '@grapecity/spread-sheets';
import {
  DATATYPE_COL_POS,
  DEFINITION_COL_POS,
  DIM1_GROUP,
  DIM2_GROUP,
  DIM3_GROUP,
  DIMENSION_COL_POS,
  HEADER_AREA,
  INTERPOLATION_COL_POS,
  LOOKUP_TABLE_PROPERTIES_HEADERS
} from './constants';

export const setupHeaders = (sheet: GC.Spread.Sheets.Worksheet) => {
  sheet.setRowCount(2, HEADER_AREA);
  sheet.setColumnCount(1, GC.Spread.Sheets.SheetArea.rowHeader);
  sheet.addSpan(0, 0, 1, LOOKUP_TABLE_PROPERTIES_HEADERS.length, HEADER_AREA);
  sheet.setValue(0, 0, 'Lookup Table Properties', HEADER_AREA);
  sheet.setValue(1, 0, LOOKUP_TABLE_PROPERTIES_HEADERS[0], HEADER_AREA);
  sheet.setValue(1, 1, LOOKUP_TABLE_PROPERTIES_HEADERS[1], HEADER_AREA);
  sheet.setValue(1, 2, LOOKUP_TABLE_PROPERTIES_HEADERS[2], HEADER_AREA);
  sheet.setValue(1, 3, LOOKUP_TABLE_PROPERTIES_HEADERS[3], HEADER_AREA);
  sheet.setValue(1, 4, LOOKUP_TABLE_PROPERTIES_HEADERS[4], HEADER_AREA);
  sheet.setValue(1, DIMENSION_COL_POS, LOOKUP_TABLE_PROPERTIES_HEADERS[DIMENSION_COL_POS], HEADER_AREA);

  sheet.addSpan(0, DIM1_GROUP.startCol, 1, DIM1_GROUP.spanCol, HEADER_AREA);
  sheet.setValue(0, DIM1_GROUP.startCol, DIM1_GROUP.title, HEADER_AREA);
  sheet.setValue(1, DIM1_GROUP.startCol + DATATYPE_COL_POS, DIM1_GROUP.headers[DATATYPE_COL_POS], HEADER_AREA);
  sheet.setValue(
    1,
    DIM1_GROUP.startCol + INTERPOLATION_COL_POS,
    DIM1_GROUP.headers[INTERPOLATION_COL_POS],
    HEADER_AREA
  );
  sheet.setValue(1, DIM1_GROUP.startCol + DEFINITION_COL_POS, DIM1_GROUP.headers[DEFINITION_COL_POS], HEADER_AREA);
  sheet.addSpan(0, DIM2_GROUP.startCol, 1, DIM2_GROUP.spanCol, HEADER_AREA);
  sheet.setValue(0, DIM2_GROUP.startCol, DIM2_GROUP.title, HEADER_AREA);
  sheet.setValue(1, DIM2_GROUP.startCol + DATATYPE_COL_POS, DIM2_GROUP.headers[DATATYPE_COL_POS], HEADER_AREA);
  sheet.setValue(
    1,
    DIM2_GROUP.startCol + INTERPOLATION_COL_POS,
    DIM2_GROUP.headers[INTERPOLATION_COL_POS],
    HEADER_AREA
  );
  sheet.setValue(1, DIM2_GROUP.startCol + DEFINITION_COL_POS, DIM2_GROUP.headers[DEFINITION_COL_POS], HEADER_AREA);
  sheet.addSpan(0, DIM3_GROUP.startCol, 1, DIM3_GROUP.spanCol, HEADER_AREA);
  sheet.setValue(0, DIM3_GROUP.startCol, DIM3_GROUP.title, HEADER_AREA);
  sheet.setValue(1, DIM3_GROUP.startCol + DATATYPE_COL_POS, DIM3_GROUP.headers[DATATYPE_COL_POS], HEADER_AREA);
  sheet.setValue(
    1,
    DIM3_GROUP.startCol + INTERPOLATION_COL_POS,
    DIM3_GROUP.headers[INTERPOLATION_COL_POS],
    HEADER_AREA
  );
  sheet.setValue(1, DIM3_GROUP.startCol + DEFINITION_COL_POS, DIM3_GROUP.headers[DEFINITION_COL_POS], HEADER_AREA);
  sheet.addSpan(0, 12, 1, 1, HEADER_AREA);
};
